/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ConfigurazioneFormTemplateDTO } from '../model/models';
import { ConfigurazioneFormTranslateResponseDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface PutTipoPraticaConfigurazioneFormRequestParams {
    id: string;
    configurazioneFormTemplateDTO: ConfigurazioneFormTemplateDTO;
}

export interface TranslateTipoPraticaConfigurazioneFormRequestParams {
    id: string;
}


export interface TipoPraticaConfigurazioneFormCittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Salva il template di form cittadino di un bando dopo validazione strutturale (sintassi $dynamic, profondita\&#39; max, params).
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{id}/configurazione-form
* @param requestParameters
     */
    putTipoPraticaConfigurazioneForm(requestParameters: PutTipoPraticaConfigurazioneFormRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormTemplateDTO>;

    /**
     * Dry-run del resolver: ritorna l\&#39;output che il cittadino riceverebbe ora dato il template salvato + lo stato corrente dei satelliti. Include warning per i $dynamic che producono 0 nodi.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/configurazione-form/translate
* @param requestParameters
     */
    translateTipoPraticaConfigurazioneForm(requestParameters: TranslateTipoPraticaConfigurazioneFormRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormTranslateResponseDTO>;

}
